module.exports = __webpack_public_path__ + "img/budget.56b0dd69.svg";